import { Node, NodeEntry, Path, Element as SlateElement } from 'slate'

import { CustomEditor, TCustomElement } from '../../interface/custom-types'

import { isList, isListItem } from './isListHelper'

/**
 * Get the nested list kept in the list item at the given path.
 * Such a list is the only child of the list item wrapping it,
 * everything else is a regular list item with content.
 */
export const getSubListEntry = (
  editor: CustomEditor,
  listItemPath: Path
): NodeEntry<TCustomElement> | undefined => {
  if (!Node.has(editor, listItemPath)) {
    return undefined
  }

  const listItemNode = Node.get(editor, listItemPath)

  if (
    !SlateElement.isElement(listItemNode) ||
    !isListItem(listItemNode) ||
    listItemNode.children.length !== 1
  ) {
    return undefined
  }

  const subListPath = [...listItemPath, 0]
  const subListNode = Node.get(editor, subListPath)

  if (!SlateElement.isElement(subListNode) || !isList(subListNode)) {
    return undefined
  }

  return [subListNode as TCustomElement, subListPath]
}
